import { optionSubcategory_customizeActions } from './customizeActionsSubCategory.locstring.json';
import { OptionSubCategory } from 'owa-options-core';
import loadCalendarMailboxAndProcessingConfig from './loadCalendarMailboxAndProcessingConfig';
import CalendarSurfaceAddinsOption from 'owa-calendar-surface-addins-option/lib/CalendarSurfaceAddinsOption';

let customizeActionsSubCategory: OptionSubCategory = {
    key: 'calendarSurfaceActions',
    titleStringKey: optionSubcategory_customizeActions,
    options: [CalendarSurfaceAddinsOption],
    onSelected: loadCalendarMailboxAndProcessingConfig,
};

export default customizeActionsSubCategory;
